import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Table, Pagination, DatePicker, Button, Modal, Tooltip, Input, Select } from 'components';
import { DeleteIcon, DownloadIcon } from 'assets/icons';
import { UserService } from 'services';
import moment from 'moment';
import ModalCreate from '../affiliate/modal-create';
import { Globals, Constants, checkPermission } from 'utils';

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	status: '',
	search_affiliate: '',
	seller_code: '',
	payment_method_id: '',
	type: 1,  // Vendedores (Membresías)
}

const paymentStatus = [
	{ value: Constants.COMMISSIONS.STATUS.PENDING.toString(), label: 'Pendiente' },
	{ value: Constants.COMMISSIONS.STATUS.PAID.toString(), label: 'Pagado' },
];

class CommissionsSeller extends React.Component<any> {

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha',
			'Código de vendedor',
			'Vendedor/Agente',
			'Afiliados',
			'Total afiliación ($)',
			'Comisión por pagar a Vendedor/Agente ($)',
			'Comisión pagada a Vendedor/Agente ($)',
			'Fecha de pago',
			// 'Método de pago',
			'Estatus de pago',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		payment_methods: [],
		banks: [],
		totals: {
			paid: 0,
			pending: 0
		},
	}

	componentDidMount() {
		this.load();
		this.getSelects();
	}

	getSelects = () => {
		Promise.all([
			UserService.admin.getBanks(),
			UserService.admin.getSelects({ without_cash: true }),
		]).then(res => {
			const banks = (res[0] as any)?.banks ?? [];
			const payment_methods = (res[1] as any)?.paymentMethods ?? [];
			this.setState({ banks, payment_methods });
		})
		.catch(console.log);
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.admin.getCommissions({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.commissions.rows,
			last_page: res.commissions.count,
			totals: res.totals,
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	pay = (item: any) => {
		this.setState({ visible: true, item });
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la comisión?',async () => {
			await UserService.admin.deleteCommission({ id: item.id });
			this.load(true);
		});
	}

	print = async () => {
		const res: any = await UserService.admin.getCommissions({
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			download: true,
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	render() {
		const { form, visible } = this.state;

		return (
			<div id="admin-commissions-seller">
				<Modal
					className="modal-create-doctor commission-payment"
					visible={ visible }
					withoutClose={ true }
					onClose={ () => this.onClose() }
				>
					<ModalCreate
						item={ this.state.item }
						onClose={ () => this.onClose() }
						onSuccess={ () => this.onClose() }
						name={'Vendedor/agente de afiliación'}
					/>
				</Modal>

				<div className="row-filter">
					<Input
						label="Vendedor/agente de afiliación"
						placeholder="Nombre"
						name="search"
						value={form.search}
						onChange={this.change}
					/>

					<Input
						label="Afiliado"
						placeholder="Nombre"
						name="search_affiliate"
						value={form.search_affiliate}
						onChange={this.change}
					/>

					<Input
						label="Código de vendedor"
						name="seller_code"
						value={form.seller_code}
						onChange={this.change}
					/>

					{/* <Select
						label="Método de pago"
						name="payment_method_id"
						onChange={this.change}
						value={form.payment_method_id}
						options={this.state.payment_methods.map((i: any) => ({ value: i.id, label: i.name }))}
					/> */}

					<Select
						label="Estatus de pago"
						name="status"
						onChange={this.change}
						value={form.status}
						options={paymentStatus}
					/>

					<DatePicker
						placeholder="Desde"
						onChange={(text: string) => this.change({ target: { value: text, name: 'since' } }) }
						value={form.since}
					/>

					<DatePicker
						placeholder="Hasta"
						onChange={(text: string) => this.change({ target: { value: text, name: 'until' } }) }
						value={form.until}
					/>
				</div>

				<div className="filter-actions">
					<Button className="btn-filter" onClick={() => this.load(true)}>
						Filtrar
					</Button>

					{this.state.form !== INITIAL_STATE && (
						<Button className="btn-clean" onClick={this.reset}>
							Limpiar
						</Button>
					)}
				</div>

				{this.props.tabs}

				<Table
					title="Comisiones"
					data={this.state.data.length}
					header={this.state.header}
					rightAlign={[10]}
					titleRight={
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>

							<div style={{
								display: 'flex',
								backgroundColor: '#ffe5b4', /* Tono naranja claro/crema */
								padding: '8px 20px',
								borderRadius: '20px',
								gap: '30px',
								color: '#000'
							}}>
								<div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
									<span style={{ fontSize: '11px', fontWeight: 'bold' }}>Total pagadas/mes</span>
									<span style={{ fontSize: '18px', fontWeight: 'bold' }}>
										{Globals.formatMiles(this.state.totals.paid)}
									</span>
								</div>

								<div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
									<span style={{ fontSize: '11px', fontWeight: 'bold' }}>Total por pagar/mes</span>
									<span style={{ fontSize: '18px', fontWeight: 'bold' }}>
										{Globals.formatMiles(this.state.totals.pending)}
									</span>
								</div>
							</div>

							{/* Botón Descargar Excel Original */}
							<Button className="btn-download" onClick={() => this.print()}>
								<img src={DownloadIcon} alt="Descargar Excel" />
								<span>Descargar Excel</span>
							</Button>
						</div>
					}
				>
					{this.state.data.map((i: any,index: number) => (
						<tr key={ index }>
							<td>{ i?.payment?.date_es ?? '--' }</td>
							<td>{ i?.user?.code }</td>
							<td>{ i?.user?.name }</td>
							<td>{ i.payment?.plan_user?.user?.name }</td>
							<td>{ Globals.formatMiles((i?.payment?.amount - i?.payment?.iva)) }</td>
							<td>{ Globals.formatMiles(i?.amount) }</td>
							<td>{ i?.status === Constants.COMMISSIONS.STATUS.PAID ? Globals.formatMiles(i?.amount) : '--' }</td>
							<td>{ i?.date ? moment(i?.date).format('DD-MM-YYYY') : '--' }</td>
							{/* <td>{ i?.payment_method?.name ?? '--' }</td> */}
							<td className="status" data-status={i.status}>{ i.status_text }</td>
							<td className="actions">
								{
									(checkPermission(Constants.MODULES.COMMISSIONS,'pay',this.props.user) && i.status === Constants.COMMISSIONS.STATUS.PENDING) && (
										<Tooltip title="Pagar">
											<button className="chip" onClick={(e: any) => this.pay(i)}>
												Pagar
											</button>
										</Tooltip>
									)
								}
								{
									checkPermission(Constants.MODULES.COMMISSIONS,'delete',this.props.user) && (
										<Tooltip title="Eliminar">
											<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
												<img src={ DeleteIcon } />
											</a>
										</Tooltip>
									)
								}
							</td>
						</tr>
					))}
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({ page: page });
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => ({
	user: state.user
}))(CommissionsSeller);